import isEmpty from 'lodash/isEmpty';
import type { RootState } from 'reducers/types';
import { EXCLUDED_INSTRUCTIONS } from '../payment/payment';

export const getInstructionByName = (state: RootState, name: string) => {
  const { entities: { instructions } = {} } = state;

  return instructions?.[name];
};

export const hasInstructions = (state: RootState) => {
  const {
    entities: { instructions },
  } = state;

  return !isEmpty(instructions);
};

export const shouldDisplayInstructions = (state: RootState) => {
  const {
    entities: { instructions },
  } = state;

  return (
    Object.keys(instructions).filter(
      key => key !== 'aba' && !EXCLUDED_INSTRUCTIONS.includes(key),
    ).length > 0
  );
};
